import { render, staticRenderFns } from "./QuestionImageUploader.vue?vue&type=template&id=03cc0097&scoped=true&"
import script from "./QuestionImageUploader.vue?vue&type=script&lang=js&"
export * from "./QuestionImageUploader.vue?vue&type=script&lang=js&"
import style1 from "./QuestionImageUploader.vue?vue&type=style&index=1&id=03cc0097&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cc0097",
  null
  
)

export default component.exports